import BackdropLoader from 'shared/lib/components/progresses/backdropLoader';
import { observer } from 'mobx-react-lite';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import React, { useContext } from 'react';

export default observer(function LoaderWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const { mobxStore } = useContext(MobxContext);

  return (
    <>
      <BackdropLoader
        open={mobxStore.stateStore.isGlobalLoader}
      ></BackdropLoader>
      {children}
    </>
  );
});
